<app-dialog
  [showHeader]="false"
  [maxWidth]="448"
  [minWidth]="448"
  [minHeight]="320"
  [blur]="true"
  [show]="true">
    <div class="loader">
        <div class="gif-container">
            <img src="assets/gifs/pill.gif" class="gif"> 
        </div>
        <!-- <div class="text">
           <div>Updating inventory...</div> 
            <div>This may take a minute or two.</div>
        </div>
       -->
    </div>
</app-dialog>